const log = Object();

//log.debug = console.log;
//log.error = console.error;
log.debug = () => {};
log.error = () => {};

export { log as Log };
